const memberGetKey = (memberId)=>memberId ? [
        'members.search.id',
        memberId
    ] : null;

export { memberGetKey };
//# sourceMappingURL=memberGetKey.mjs.map
